module.exports = __webpack_public_path__ + "img/shopmania_canvas.3bf9611d.png";